import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HabitsConfiguration } from 'src/app/analyses/interfaces/analyses.types';
import { AnalysesService } from 'src/app/analyses/services/analyses.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireService {
  constructor(
    private http: HttpClient,
    private readonly analysesService: AnalysesService
  ) {}

  public getHabitsConfigurations(): Observable<HabitsConfiguration[]> {
    return this.http.get<HabitsConfiguration[]>(
      '/api/habits/configurations/lifestyle'
    );
  }

  saveQuestionnaire(): Observable<{ id: string } | null> {
    const data = this.analysesService.local.getQuestionnaire();

    if (!data?.questions.length) {
      return of(null);
    }

    return this.analysesService
      .saveQuestionnaire(data)
      .pipe(tap(() => this.analysesService.local.clearQuestionnaire()));
  }
}
